import script from "./TheUnboxing.vue?vue&type=script&setup=true&lang=js"
export * from "./TheUnboxing.vue?vue&type=script&setup=true&lang=js"

import "./TheUnboxing.vue?vue&type=style&index=0&id=029530ee&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029530ee"]])

export default __exports__